<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-card class="rounded-lg">
          <card-header
            :title="$t('title.edit_published_paper')"
            icon="toc"
            color="primary"
            variant="gradient"
          ></card-header>

          <v-card-text>
            <v-row>
              <v-col cols="12" v-if="journalContent.authors.length > 0">
                <div class="d-flex align-center justify-space-between mb-2">
                  <h6 class="text-h6 font-weight-bold ma-2">
                    {{ $t("label.author_info") }}
                  </h6>
                  <div class="d-flex align-center">
                    <custom-button
                      :label="$t('button.preview')"
                      color="black"
                      size="lg"
                      gradient
                      rounded
                      @click="generatePdfPreview"
                    />
                  </div>
                </div>
                <v-card
                  v-for="(author, index) in journalContent.authors"
                  :key="index"
                  class="mb-2 rounded-lg"
                  elevation="0"
                  outlined
                >
                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="12" xl="2  " lg="2" md="2" sm="12">
                        <v-text-field
                          v-model="author.given_name"
                          :label="$t('label.author_given_name')"
                          required
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xl="2  " lg="2" md="2" sm="12">
                        <v-text-field
                          v-model="author.surname"
                          :label="$t('label.author_surname')"
                          required
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xl="2  " lg="2" md="2" sm="12">
                        <v-text-field
                          v-model="author.full_name"
                          :label="$t('label.author_full_name')"
                          required
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xl="2" lg="2" md="2" sm="12">
                        <v-text-field
                          v-model="author.name_eng"
                          :label="$t('label.author_name_eng')"
                          required
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" xl="2" lg="2" md="2" sm="12">
                        <v-text-field
                          v-model="author.email"
                          :label="$t('label.author_email')"
                          required
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                        <v-text-field
                          v-model="author.organization"
                          :label="$t('label.author_organization')"
                          required
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                        <v-text-field
                          v-model="author.organization_eng"
                          :label="$t('label.author_organization_eng')"
                          required
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                        <v-text-field
                          v-model="author.department"
                          :label="$t('label.author_department')"
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                        <v-text-field
                          v-model="author.position"
                          :label="$t('label.author_position')"
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <hr class="border-dashed" />

                <div class="d-flex align-center justify-left">
                  <h6 class="text-h6 font-weight-bold ma-2">
                    {{ $t("label.submission_info") }}
                  </h6>
                </div>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                <v-text-field
                  :value="journalContent.journal.title"
                  :label="$t('label.journal')"
                  hide-details="auto"
                  class="mb-4 ml-3"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- 제목 -->
                <v-text-field
                  v-model="journalContent.title"
                  :label="$t('label.title')"
                  hide-details="auto"
                  class="mb-4 ml-3 mr-3"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- 제목(영문) -->
                <v-text-field
                  v-model="journalContent.title_eng"
                  :label="$t('label.title_eng')"
                  hide-details="auto"
                  class="mb-4 ml-3 mr-3"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- 부제목(국문) -->
                <v-text-field
                  v-model="journalContent.subtitle"
                  :label="$t('label.subtitle')"
                  hide-details="auto"
                  class="mb-4 ml-3 mr-3"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- 부제목(영문) -->
                <v-text-field
                  v-model="journalContent.subtitle_eng"
                  :label="$t('label.subtitle_eng')"
                  hide-details="auto"
                  class="mb-4 ml-3 mr-3"
                ></v-text-field>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                <!-- 키워드(국문) -->
                <v-text-field
                  v-model="journalContent.keyword"
                  :label="$t('label.keyword')"
                  hide-details="auto"
                  class="mb-4 ml-3 mr-3"
                ></v-text-field>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                <!-- 키워드(영문) -->
                <v-text-field
                  v-model="journalContent.keyword_eng"
                  :label="$t('label.keyword_eng')"
                  hide-details="auto"
                  class="mb-4 ml-3 mr-3"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-row>
                  <v-col
                    cols="12"
                    xl="6"
                    lg="6"
                    md="12"
                    sm="12"
                    v-if="journalContent.journal.journal_type.code === 'abst'"
                  >
                    <!-- 초록(국문) -->
                    <submission-editor-card
                      :value="journalContent.abstract"
                      @update-content="updateField('abstract', $event)"
                      class="mb-4"
                      :height="500"
                      :comments="journalContent.comments"
                      @update:comments="journalContent.comments = $event"
                    >
                      <template v-slot:card-header>
                        <v-card-title
                          class="text-subtitle-1 font-weight-regular"
                        >
                          {{ $t("label.abstract") }}
                        </v-card-title>
                      </template>
                    </submission-editor-card>
                  </v-col>

                  <v-col
                    cols="12"
                    xl="6"
                    lg="6"
                    md="12"
                    sm="12"
                    v-if="journalContent.journal.journal_type.code != 'abst'"
                  >
                    <!-- 본문(국문) -->
                    <submission-editor-card
                      :value="journalContent.content"
                      @update-content="updateField('content', $event)"
                      class="mb-4"
                      :height="800"
                      :comments="journalContent.comments"
                      @update:comments="journalContent.comments = $event"
                    >
                      <template v-slot:card-header>
                        <v-card-title
                          class="text-subtitle-1 font-weight-regular"
                        >
                          {{ $t("label.content") }}
                        </v-card-title>
                      </template>
                    </submission-editor-card>
                  </v-col>

                  <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                    <!-- 제목 -->
                    <div class="d-flex justify-space-between align-center">
                      <div class="d-flex flex-column">
                        <h4 class="text-subtitle-1 font-weight-medium">
                          {{ $t("label.comment") }}
                        </h4>
                        <div class="d-flex flex-row align-center mb-2">
                          <v-icon color="orange" size="small">
                            mdi-information-outline
                          </v-icon>
                          <p
                            class="text-subtitle-2 font-weight-regular ml-1 mb-0"
                          >
                            {{ $t("txt.add_paper_comment_description") }}
                          </p>
                        </div>
                      </div>
                      <v-btn
                        color="green"
                        small
                        icon
                        @click="handleAddComment"
                        :disabled="
                          journalContent.journal.journal_type.code === 'abst'
                        "
                        ><v-icon>mdi-plus</v-icon></v-btn
                      >
                    </div>

                    <!-- 주석 목록 -->
                    <v-card
                      outlined
                      height="800"
                      class="rounded-lg overflow-y-auto"
                    >
                      <v-card-text>
                        <v-card
                          v-for="(comment, index) in journalContent.comments"
                          :key="index"
                          class="ma-1 rounded-lg"
                          outlined
                        >
                          <v-card-text>
                            <div class="d-flex justify-space-between">
                              <div class="d-flex flex-row">
                                <v-text-field
                                  v-model="comment.page"
                                  label="페이지"
                                  type="number"
                                  outlined
                                  dense
                                  class="mr-2"
                                  :rules="[rules.required]"
                                ></v-text-field>
                                <v-text-field
                                  v-model="comment.superscript"
                                  label="첨자"
                                  outlined
                                  dense
                                  :rules="[rules.required]"
                                ></v-text-field>
                              </div>

                              <div class="d-flex flex-row">
                                <v-btn
                                  text
                                  color="pink"
                                  @click="handleDeleteComment(comment, index)"
                                  class="mr-2"
                                >
                                  {{ $t("button.delete") }}
                                </v-btn>
                              </div>
                            </div>
                            <v-textarea
                              v-model="comment.content"
                              label="내용"
                              :rules="[rules.required]"
                              outlined
                              dense
                            ></v-textarea>
                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <!-- 버튼 영역 -->
              <v-row class="mt-12">
                <v-col cols="12" class="d-flex justify-space-between">
                  <custom-button
                    :label="$t('button.close')"
                    color="black"
                    rounded
                    gradient
                    class="mr-2"
                    @click="handleClose"
                  />

                  <div>
                    <custom-button
                      :label="$t('button.save')"
                      color="primary"
                      rounded
                      gradient
                      @click="handleSave"
                    />
                  </div>
                </v-col>
              </v-row>

              <v-col cols="12">
                <!-- PDF 콘텐츠 (숨겨진 상태로 렌더링) -->
                <div ref="pdfContent" style="display: none">
                  <!-- <div ref="pdfContent" style="background-color: white; width: 210mm;"> -->
                  <component
                    v-if="journalContent"
                    :is="selectedPdfTemplate"
                    :item="journalContent"
                    :journal="journalContent?.journal"
                    :startPageNumber="startPageNumber"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardHeader from "@/components/cards/CardHeader.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";
import SubmissionEditorCard from "@/components/common/Cards/SubmissionEditorCard.vue";

import ArticlePaperPage from "@/components/Templates/article/ArticlePaperPage.vue";
import AbstractPaperPage from "@/components/Templates/abstract/AbstractPaperPage.vue";
import ProceedingsPaperPage from "@/components/Templates/proceedings/ProceedingsPaperPage.vue";

import { closePopup, savePopup } from "@/fields/paper/popups";

import { generateFinalPdf } from "@/utils/pdfGenerator";

import { journalContentApi } from "@/api/api";

export default {
  name: "edit-published-paper",
  components: {
    CustomButton,
    CardHeader,
    SubmissionEditorCard,
    LoadingSpinner,
    ArticlePaperPage,
    AbstractPaperPage,
    ProceedingsPaperPage,
  },
  props: {
    idx: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      journalContent: {
        title: "",
        title_eng: "",
        subtitle: "",
        subtitle_eng: "",
        keyword: "",
        keyword_eng: "",
        abstract: "",
        content: "",
        authors: [],
        journal: {
          title: "",
          journal_type: {
            code: "",
          },
        },
        authors: [],
      },
      isLoading: false,
      rules: {
        required: (value) => !!value || this.$t("valid.required_field"),
      },
    };
  },
  methods: {
    handleAddComment() {
      if (!this.journalContent?.comments) {
        this.journalContent.comments = [];
      }

      this.journalContent.comments.push({
        page: null,
        superscript: null,
        content: null,
      });
    },
    async handleDeleteComment(comment, index) {
      this.journalContent.comments.splice(index, 1);
    },
    async fetchContent() {
      try {
        this.isLoading = true;

        const response = await journalContentApi.showJournalContent({
          idx: this.idx,
        });

        if (response.status === 200) {
          this.journalContent = response.data.response;
        }
      } catch (error) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
        });
      } finally {
        this.isLoading = false;
      }
    },

    async updateJournalContent() {
      try {
        const response = await journalContentApi.updateJournalContent(
          this.journalContent
        );

        if (response.status === 200) {
          this.notifyVue({
            message: this.$t("alert.success_request"),
            style: "success",
          });
          await this.fetchContent();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_request"),
        });
      } finally {
        this.isLoading = false;
      }
    },
    generatePdfPreview() {
      const element = this.$refs.pdfContent;

      if (!element) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
        });
        return;
      }

      generateFinalPdf({ element: element });
    },
    async handleSave() {
      const isConfirmed = await savePopup();

      if (!isConfirmed) {
        return;
      }

      this.updateJournalContent();
    },
    async handleClose() {
      const isConfirmed = await closePopup();

      if (!isConfirmed) {
        return;
      }

      this.toPaperPublishManagement();
    },
    updateField(field, value) {
      this.journalContent[field] = value;
    },
    toPaperPublishManagement() {
      this.$router.push({ name: "paper-publish-management" });
    },
    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.fetchContent();
  },
  computed: {
    selectedPdfTemplate() {
      if (this.journalContent?.journal?.journal_type?.code === "abst") {
        return "abstract-paper-page";
      } else if (this.journalContent?.journal?.journal_type?.code === "procs") {
        return "proceedings-paper-page";
      }
      return "article-paper-page";
    },
    startPageNumber() {
      if (this.journalContent?.journal?.journal_type?.code === "jnl") {
        return 2;
      }
      return 1;
    },
  },
};
</script>

<style scoped>
.border-dashed {
  border-style: dashed;
  border-width: 0.5px;
  border-color: #a7a7a7;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
